import dayjs from "dayjs";

export const avatarPath = (userId: string, tenantId: number) =>
  `branches/${tenantId}/${userId}/images/avatar/avatar.png`;

export const invoicePath = (tenantId: number, branchId: string, invoiceNumber: string, createdAt: Date) =>
  `tenants/${tenantId}/${branchId}/invoices/${dayjs(createdAt).format("YYYY")}/${invoiceNumber}.pdf`;
